import * as React from 'react';

import StatusLabel from 'components/status-label/StatusLabel';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Spinner from 'components/spinner/Spinner';

import ClientApprovalEntryActions from '../client-approval-entry-actions/ClientApprovalEntryActions';

import ClientApprovalGalleryContext from '../../context/ClientApprovalGalleryContext';

import { __t, applyTranslations } from 'utils/language';

import './client-approval-entry-gallery-helper.scss';

applyTranslations(require('./client-approval-entry-gallery-helper.i18n.json'));

const ClientApprovalEntryGalleryOverlay = (selectedItem, items, dispatchMarkAsFavourite): React.ReactNode => {
  const currentItem = items?.find(item => selectedItem.id === item.id);

  if (!currentItem) {
    return null;
  }

  const isReviewed = currentItem.status === 'approved' || currentItem.status === 'declined';

  const handleMarkAsFav = async (event: React.SyntheticEvent<HTMLElement>) => {
    event.stopPropagation();

    if (currentItem.bucketId && dispatchMarkAsFavourite) {
      dispatchMarkAsFavourite(!currentItem.favourite, currentItem.bucketId, Number(currentItem.id));
    }
  };

  return (
    <ClientApprovalGalleryContext.Consumer>
      {
        (context) => {
          if (!context) {
            return null;
          }

          return (
            <React.Fragment>
              <div className="client-approval-entry-gallery-overlay__title">
                {context.look}
                {
                  currentItem.status === 'approved' && (
                    <div
                      className="client-approval-entry-gallery-overlay__like"
                    >
                      {
                        currentItem.isMarkAsFavLoading ? (
                          <Spinner
                            position="inline"
                            size="tiny"
                            color="light"
                          />
                        ) : (
                          <SVGDynamicIcon
                            onClick={handleMarkAsFav}
                            name="heart-custom-bg"
                            width={16}
                            height={16}
                            customColor={currentItem.favourite ? 'red' : 'white'}
                          />
                        )
                      }
                    </div>
                  )
                }
              </div>
              <div className="client-approval-entry-gallery-overlay__body">
                {isReviewed && currentItem.status === 'approved' && (
                  <StatusLabel
                    size="normal"
                    type="success"
                    background="transparent"
                    label={__t('client_approval_entry_gallery_helper.status.approved')}
                  />
                )}
                {isReviewed && currentItem.status === 'declined' && (
                  <StatusLabel
                    size="normal"
                    type="danger"
                    background="transparent"
                    label={__t('client_approval_entry_gallery_helper.status.declined')}
                  />
                )}
                {!isReviewed && (
                  <ClientApprovalEntryActions
                    onApprove={() => context.onAssetApprovalChange(Number(selectedItem.id), 'approved')}
                    onDecline={() => context.onAssetApprovalChange(Number(selectedItem.id), 'declined')}
                  />
                )}
              </div>
            </React.Fragment>
          );
        }
      }
    </ClientApprovalGalleryContext.Consumer>
  );
};

export default ClientApprovalEntryGalleryOverlay;
